import { render } from "./GoalsView.vue?vue&type=template&id=07a92a76"
import script from "./GoalsView.vue?vue&type=script&lang=js"
export * from "./GoalsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__